import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { ViewTitle } from '../components/reusable'
import { FairclaimApiView } from '../components/views/fairclaimApiView'

function FairclaimApi() {
    return (
        <div className="fairclaimApi">
            <Sidebar />
            <MainView>
                <ViewTitle text={'Claim Delivery API'} />
                <FairclaimApiView />
            </MainView>
        </div>
    )
}

export default FairclaimApi
